import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
/**
 * Generated class for the FormatPricePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'sliceMessage',
})
export class SliceMessagePipe implements PipeTransform {
  /**
   * Takes a job and displays the compensation in a human readable format Based
   * on the following fields:

   */

  sliceMessage = function (value, length = 100) {
    return _.truncate(value, { length, omission: ' ...' });
  };

  transform(value: any, ...args) {
    return this.sliceMessage(value, args[0]);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/splice-text/splice-message.ts